module.exports = __webpack_public_path__ + "img/2-3.59eb5894.jpg";